<template>
	<div class="lins">
		<div class="informationtitle">
			<span class="heti">Latest</span>
			<span>News</span>
		</div>
  <mt-swipe v-bind:style="getBannerStyle" :showIndicators="isShowIndicators">
    <mt-swipe-item v-for="(item, index) in items" :key="index">
      <img :style="getBannerStyle" v-lazy="item.adv_code" v-if='item.adv_code' @click="goAdUrl(item)">
      <img :style="getBannerStyle" src="../../../assets/image/home/default_image_banner.png" v-else>
    </mt-swipe-item>
  </mt-swipe>
  </div>
</template>

<script>
export default {
  name: 'IndexBanner',
  data () { 	
    return {
    }
  },
  props: ['items'],
  computed: {
    getBannerStyle: function () {
      const { width } = window.screen
      let itemWidth = width
      let itemHeight = width/2.2
      return {
        width: 100 + '%',
        height: itemHeight + 'px'
      }
    },
    isShowIndicators () {
      if (this.items && this.items.length > 1) {
        return true
      }
      return false
    }
  },
  methods: { 	
    goAdUrl (item) {
      switch (item.adv_type) {
        case 'goods':
          this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: item.adv_typedate } })
          break
        case 'store':
          this.$router.push({ name: 'HomeStoredetail', query: { id: item.adv_typedate } })
          break
        case 'article':
          this.$router.push({ name: 'HomeArticledetail', query: { article_id: item.adv_typedate } })
          break
        case 'url':
          window.location.href=item.adv_typedate
          break  
      }
    }
  }
}
</script>

<style>
	.lins{margin: 1rem 0;}
	.lins .mint-swipe-indicator{width: 13px;height: 13px;background-color: #fff;opacity: 1;}
body .lins .mint-swipe{overflow: inherit;}
body .lins .mint-swipe-items-wrap{border-radius: 0px;}
body .lins .mint-swipe-indicators .is-active{background-color: #ff0000;opacity: 1;}
body .lins .mint-swipe-indicators{bottom: -1.2rem;}
.informationtitle{text-align: center;padding-bottom: 0.5rem;}
.informationtitle span{display: inline-block;font-size: 1.1rem;color: #FF0000;font-weight: bold;}
.informationtitle span.heti{font-size: 0.7rem;border-bottom: 0.25rem solid #FF0000;color: #000;vertical-align: text-bottom;}
</style>
